export default __webpack_public_path__ + "2e43ad991eb141fc017fa26b395bfd5f.svg";